import { useState, useEffect } from 'react';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-0">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>日更连载 · 万部漫画免费看</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              酷看漫画
              <span className="block text-primary-500">韩漫日漫国漫分类大全</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              将韩漫、日漫、国漫精心分类整理，汇集玄幻、恋爱、热血等热门类型，免费在线阅读，找好看的漫画一搜即达。每日更新数百话，追更不等待，阅读体验流畅舒适，漫画世界尽在指尖。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-500">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">追更不等待</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-500">全免费</div>
                <div className="text-xs text-foreground-500 mt-1">无需付费</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer no-underline"
              >
                <i className="ri-compass-3-line"></i>
                开始探索
              </a>
              <a
                href="#ranking"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-200 text-foreground-700 font-semibold text-sm hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer no-underline"
              >
                <i className="ri-bar-chart-line"></i>
                查看排行榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: '4/3' }}>
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20colorful%20manga%20and%20comic%20illustration%20scene%20with%20floating%20comic%20book%20panels%20and%20dynamic%20motion%20lines%2C%20warm%20orange%20and%20coral%20tones%20on%20a%20clean%20light%20background%2C%20stylized%20anime%20art%20aesthetic%20with%20soft%20gradients%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20modern%20and%20artistic%20feel%2C%20harmonious%20warm-tone%20composition&width=800&height=600&seq=hero-manga-visual&orientation=landscape"
                alt="酷看漫画 - 韩漫日漫国漫免费在线阅读平台"
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}